// Vendors
import { StyleSheet, Text, View, Image } from "@react-pdf/renderer";
import dayjs from "dayjs";
import "dayjs/locale/es";
import utc from "dayjs/plugin/utc";

// Set locale
dayjs.locale("es");
dayjs.extend(utc);

const styles = StyleSheet.create({
  root: {
    padding: "20px 60px",
    fontFamily: "Source Sans",
    fontSize: 12,
    lineHeight: 1.5,
  },
  topLogo: {
    height: 130,
    alignSelf: "center",
    marginBottom: 40,
    objectFit: "contain",
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 40,
    textTransform: "uppercase",
  },
  paragraph: {
    textAlign: "justify",
    marginBottom: 20,
  },
  dateText: {
    textAlign: "right",
    marginTop: 20,
    marginBottom: 20,
  },
  signatureBlock: {
    marginTop: 60,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  stamp: {
    width: 70,
    height: 70,
    marginRight: 20,
    objectFit: "contain",
  },
  signatureTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  signatureText: {
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: 10,
  },
});

interface IProps {
  data: any;
}

export const Body: React.FC<IProps> = ({ data }) => {
  const { user, workSeniority } = data;

  // Sort workSeniority by date ascending
  const sortedWork =
    workSeniority
      ?.slice()
      .sort((a: any, b: any) =>
        dayjs(a.contrato_desde).diff(dayjs(b.contrato_desde))
      ) || [];

  const formatDate = (date: string) => {
    if (!date) return "";
    return dayjs.utc(date).format("DD [de] MMMM [de] YYYY");
  };

  const name = workSeniority?.[0]?.nombre?.toUpperCase() || "";
  const rut = user?.rut || "";
  const currentYear = dayjs().year();

  const generateContent = () => {
    if (sortedWork.length === 0)
      return "No hay información laboral disponible.";

    const firstJob = sortedWork[0];
    const lastJob = sortedWork[sortedWork.length - 1];

    const date1 = formatDate(firstJob.contrato_desde);
    const role1 = firstJob.desc_cargo;
    let category1 = firstJob.categoria_contrato;
    if (category1 === "Plazo Fijo") {
      category1 = "Contrata";
    }

    let text = `La persona que suscribe, certifica que Don/Doña ${name}, cédula de identidad N°${rut}, se integró a esta Casa de Estudios el ${date1} `;

    if (sortedWork.length > 1) {
      const role2 = lastJob.desc_cargo;
      let category2 = lastJob.categoria_contrato;
      if (category2 === "Plazo Fijo") category2 = "Contrata";
      const grade = lastJob.grado;

      text += `como ${role2}, en calidad jurídica ${category2}`;

      if (grade) {
        text += `, asimilado al grado ${grade}° de la Escala de Remuneraciones de la Universidad de Aysén`;
      }
    } else {
      const grade = firstJob.grado;
      if (grade) {
        text += `como ${role1}, en calidad jurídica ${category1} asimilado al grado ${grade}° de la Escala de Remuneraciones de la Universidad de Aysén`;
      }
    }

    text += `, manteniendo a la fecha su vínculo contractual con esta Universidad.`;

    return text;
  };

  return (
    <View style={styles.root}>
      <Image src="/tenant/logo_small.png" style={styles.topLogo} />
      <Text style={styles.title}>CERTIFICADO N°028/{currentYear}</Text>

      <Text style={styles.paragraph}>{generateContent()}</Text>

      <Text style={styles.paragraph}>
        Se extiende el presente certificado a solicitud del interesado(a) para
        los fines que estime conveniente.
      </Text>

      <div style={{ paddingTop: "100px" }}>
        <View style={styles.signatureBlock}>
          <Image src="/tenant/stamp.png" style={styles.stamp} />
          <View style={styles.signatureTextContainer}>
            <Text style={styles.signatureText}>JEFE DE UNIDAD</Text>
            <Text style={styles.signatureText}>
              DIRECCION DE ADMINISTRACION Y FINANZAS
            </Text>
            <Text style={styles.signatureText}>UNIVERSIDAD DE AYSÉN</Text>
          </View>
        </View>
      </div>

      <div style={{ paddingTop: "100px" }}>
        <Text style={styles.dateText}>
          COYHAIQUE, {dayjs().format("DD [de] MMMM [de] YYYY")}
        </Text>
      </div>
    </View>
  );
};
